<template>
  <div class="personAce section-main__warp">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.personAce {
    width: 100%;
    height: 100%;
}
</style>